export default {
    install(app, options) {
        // custom data
        app.config.globalProperties.$customHeaderData = [];
        app.config.globalProperties.$addCustomHeaderData = function (customHeaderData) {
            app.config.globalProperties.$customHeaderData = customHeaderData;
        }
    }
}
